import { styled } from "@mui/material/styles";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";


const adGroups = [
  {
    title: "Analytical SME",
    adGroup: "MIDAS.ROLE.MASTERDATA.ANALYTICAL.UG",
    roleName: "ANALYTICAL.SME",
    description: "Allows the User to edit test methods (Analytical Master Data / Admin Module) and supervise analytical technicians (Analytical Services Module)",
  },
  {
    title: "Analytical Worker",
    adGroup: "MIDAS.ROLE.ANALYTICAL.WORKER.UG",
    roleName: "ANALYTICAL.WORKER",
    description: "Allows the User to run analytical tests, active tests (also required for SMG Smart Cart App) and enter analytical data (Analytical Services Module)",
  },
  {
    title: "Blend Formulator",
    adGroup: "MIDAS.ROLE.BLEND.FORMULATOR.UG",
    roleName: "BLEND.FORMULATOR",
    description: "Allows the User to update any Blend Study (other user's studies and their own) in Design Study. Note: All Users can update their own Blend Studies without this role"
  },
  {
    title: "Blend SME",
    adGroup: "MIDAS.ROLE.MASTERDATA.BLEND.UG",
    roleName: "BLEND.SME",
    description: "Allows the User to edit Blend Facilities (Blend Master Data / Admin Module)",
  },
  {
    title: "Blend Worker",
    adGroup: "MIDAS.ROLE.BLEND.WORKER.UG",
    roleName: "BLEND.WORKER",
    description: "Allows the User to work on, assign and prepare blend batches (Blend Module)",
  },
  {
    title: "Distillation SME",
    adGroup: "MIDAS.ROLE.MASTERDATA.DISTILLATION.UG",
    roleName: "DISTILLATION.SME",
    description:
      "Allows the User to manage and edit all Distillation Experiments and Templates (other user's Experiments/Templates and their own). Note: All Users can update their own Experiments or Templates without this role",
  },
  {
    title: "Distillation Worker",
    adGroup: "MIDAS.ROLE.DISTILLATION.WORKER.UG",
    roleName: "DISTILLATION.WORKER",
    description:
      "Allows the User to manage, process and complete distillation requests (Distillation Module)",
  },
  {
    title: "EMBSI Worker",
    adGroup: "MIDAS.ROLE.EMBSI.WORKER.UG",
    roleName: "EMBSI.WORKER",
    description: "Allows the User to create and maintain EMBSI Use Only Samples and Containers",
  },
  {
    title: "Project SME",
    adGroup: "MIDAS.ROLE.PROJECTADMIN.UG",
    roleName: "PROJECT.SME",
    description:
      "Allows the User to manage Project setup, including for non-owned Projects (Admin Module)",
  },
  {
    title: "SDS Request Worker",
    adGroup: "MIDAS.ROLE.SDSREQUEST.WORKER.UG",
    roleName: "SDSREQUEST.WORKER",
    description: "Allows the User to process an SDS Request",
  },
  {
    title: "SHE SME",
    adGroup: "MIDAS.ROLE.MASTERDATA.SHE.UG",
    roleName: "SHE.SME",
    description:"Allows the User to add and edit all ChemIDs in Manage Substances (note: owners of ChemIDs can edit their own substances); only Users with this role can add new CAS, STK or MBL substance categories (Inventory Module).  Allows the User to process and complete New Chemical Authorizations (Inventory Module)"
  },
  {
    title: "Site SME",
    adGroup: "MIDAS.ROLE.MASTERDATA.SITE.UG",
    roleName: "SITE.SME",
    description:
      "Allows the User to add and edit Site and Location Master Data (Admin Module)",
  },
  {
    title: "Special Analysis Worker",
    adGroup: "MIDAS.ROLE.SPECIALANALYSIS.WORKER.UG",
    roleName: "SPECIALANALYSIS.WORKER",
    description: "Allows the user to process a Special Analysis Request",
  },
  {
    title: "SQC SME",
    adGroup: "MIDAS.ROLE.MASTERDATA.SQC.UG",
    roleName: "SQC.SME",
    description:
      "Allows the User to add and maintain SQC/QC setup data to existing MethodFacilities and update SQC/QC data in the MIDAS SQC system",
  },
  {
    title: "SQC Viewer",
    adGroup: "MIDAS.ROLE.SQC.VIEWER.UG",
    roleName: "SQC.VIEWER",
    description: "Allows the User to view SQC/QC data in the MIDAS SQC system",
  },
  {
    title: "SQC Worker",
    adGroup: "MIDAS.ROLE.SQC.WORKER.UG",
    roleName: "SQC.WORKER",
    description: "Allows the User to enter SQC/QC data in the MIDAS SQC system",
  },
  {
    title: "Stationary Test SME",
    adGroup: "MIDAS.ROLE.MASTERDATA.ST.UG",
    roleName: "STATIONARYTESTING.SME",
    description:
      "Allows the User to edit Stationary Testing Master Data (Admin Module)",
  },
  {
    title: "Stationary Test Worker",
    adGroup: "MIDAS.ROLE.ST.WORKER.UG",
    roleName: "STATIONARYTESTING.WORKER",
    description:
      "Allows the User to process Stationary Testing requests.",
  },
  {
    title: "STLC SME",
    adGroup: "MIDAS.ROLE.MASTERDATA.STLC.UG",
    roleName: "STLC.SME",
    description: "Allows the User to manage Component Procurement and STLC (Inventory Module).",
  },
  {
    title: "Stockroom Worker",
    adGroup: "MIDAS.ROLE.STOCKROOM.WORKER.UG",
    roleName: "STOCKROOM.WORKER",
    description: "Allows the User access and edit permissions for Stockroom Management (Stockroom Module) and Stockroom Master Data (Admin Module).",
  },
  {
    title: "Work Request SME",
    adGroup: "MIDAS.ROLE.MASTERDATA.WORKREQUEST.UG",
    roleName: "WORKREQUEST.SME",
    description: "Allows the User to edit Work Request Master Data (Admin Module)",
  },
  {
    title: "Work Request Worker",
    adGroup: "MIDAS.ROLE.WORKREQUEST.WORKER.UG",
    roleName: "WORKREQUEST.WORKER",
    description: "Allows the User to process a Work Request",
  },
];

const Roles = ({ ...props }) => {
  const StyledTable = styled(Table)(() => ({
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    padding: "5px 8px",
    verticalAlign: "top",
    fontFamily: "EMprint",
    fontSize: "14px",
    color: "#000000",
  }));

  const StyledHeaderCell = styled(TableCell)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: "#f5f5f5",
    fontWeight: 700,
    fontFamily: "EMprint",
    fontSize: "14px",
    color: "#000000",
    width: "auto",
  }));

  return (
    <div>
      <div style={{ marginBottom: "1rem", lineHeight: 1.8, fontSize: "18px" }}>
        <div>By default, all users with an ExxonMobil email address who connect through a CME computer have an account in Midas3.</div>
        <div>
          Specific <b>Roles</b> are required for certain functionality within the Midas3 system. A list of roles and their associated uses is provided below.
        </div>
        <div style={{ marginTop: "0.5rem" }}>
          To request a new role, click {" "}
          <a
            href="https://vega.identitynow.com/ui/d/request-center"
            target="_blank"
            rel="noopener noreferrer">
            here
          </a>.
        </div>
        <div>
          For more information, refer to the Midas Instruction Manual: {" "}
          <a
            href="https://wiki.na.xom.com/index.php/Midas3_Instruction_Manual#Midas3_Roles"
            target="_blank"
            rel="noopener noreferrer">
            Additional Roles Information
          </a>.
        </div>
      </div>

      <TableContainer component={Paper} sx={{ boxShadow: "none", border: "1px solid rgba(0,0,0,0.12)" }}>
        <StyledTable>
          <TableHead>
            <TableRow>
              <StyledHeaderCell sx={{ width: "230px" }}>MIDAS Role Name</StyledHeaderCell>
              <StyledHeaderCell sx={{ width: "340px" }}>IGA Entitlement Group</StyledHeaderCell>
              <StyledHeaderCell sx={{ maxWidth: "500px" }}>Purpose & Description</StyledHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {adGroups.map((group, index) => (
              <TableRow key={`${group.roleName}-${index}`}>
                <StyledTableCell>{group.roleName}</StyledTableCell>
                <StyledTableCell>{group.adGroup}</StyledTableCell>
                <StyledTableCell>{group.description}</StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </StyledTable>
      </TableContainer>
      <div style={{ marginTop: "1rem" }}>
        <br />
      </div>
    </div>
  );
};

export default Roles;
